export default __webpack_public_path__ + "static/media/ico_zoom_refresh.01a1e03b.svg";